import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Header, Stepper } from './header.model';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from './header.service';
import { OAuthService } from 'src/app/shared/oAuth/oauth-service';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/core/data.service';
import { MatDialog } from '@angular/material/dialog';
import { SupportingDocumentClaimsComponent } from '../supporting-document-claims/supporting-document-claims.component';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  headerData: Header = new Header();
  emitStepperData: Stepper[] = [];
  userName: string = null;
  userId: string;
  creditorId:string;
  podId:string;
  companyNameByUserId: any;
  isManageUser: boolean;
  isPostLogin:boolean=false;
  supportingDocumentLabel="View Request(s) for Supporting Documents";
  submitOrViewMeetingLabel="Submit/View Meeting Form(s) & Documents";
  labelCaption:any;
  broadcastDetails :any[]=[];
  showSubmitOrViewMeeting:boolean=false;
  isFormHeader:boolean=false;
  @Input('header-data') set _headerdata(val) {
    this.headerData = val;
  }
  //Added labelcaption input decorator
  @Input('label-caption') set _labelcaption(val) {
    this.labelCaption = val;
  }
  @Output() emitStepper: EventEmitter<any>;
  @Output() emitAction: EventEmitter<any>;
  constructor(private router: Router,private headerService:HeaderService, public dialog: MatDialog, private OAuthService:OAuthService,private dataService: DataService ,
    private activatedRoute: ActivatedRoute,private spinnerService: NgxSpinnerService) {
    this.emitStepper = new EventEmitter<any>();
    this.emitAction = new EventEmitter<any>();
  }

  ngOnInit(): void {
    this.userId = sessionStorage.getItem('userId');
    this.userName = sessionStorage.getItem('userName');
    this.creditorId = this.activatedRoute.snapshot.paramMap.get('creditorId');
    this.podId=this.activatedRoute.snapshot.paramMap.get('podId');
    if (this.userId) {
      this.isPostLogin=true;
      this.headerService.getCompanyName(this.userId).subscribe((companyNameApiResponse: any) => {
        this.companyNameByUserId = companyNameApiResponse;
        if (this.companyNameByUserId[0]) {
          this.isManageUser = true;
        }
        else {
          this.isManageUser = false;
        }
      });
    }
    if(this.creditorId && this.headerData?.engagementId){
      this.checkBroadcastNamePublishDateById()
    }
   }

   checkBroadcastNamePublishDateById() {
      this.spinnerService.show();
      let path: string = 'broadcasts/checkbroadcastnamepublishdatebyid?engagementId=' + this.headerData?.engagementId +'&creditorId='+this.creditorId;
      this.dataService.getRequest(path).subscribe((broadcastResponse: any[]) => {
        this.broadcastDetails = broadcastResponse;
          if(this.broadcastDetails.length==0){
          this.showSubmitOrViewMeeting=false;
        }
        else{
          this.showSubmitOrViewMeeting=true;  
        }
        this.spinnerService.hide();
      });
    }

  userdetails() {

    this.router.navigate(['user-profile']);
  }
  
  redirectToRegistrationFilling() {
    this.router.navigate(['RegistrationFilling']);
  }
  onCLickToNavigateToManageUser(){
    this.router.navigate(['user-account-details']);
  }
  onClickWithdraw() {
    this.emitAction.emit('Withdraw'); 
  }
  onClickWithdrawResubmit() {
    this.emitAction.emit('WithdrawResubmit');
  }
  onCLickToNavigateToFAQ(){
    this.router.navigate(['creditorhome/faq']);
  }
  onClickLogout() {
    if(sessionStorage.getItem('isMyAccountEdit') == 'true'){
      let lockDetails:any={
        lockId:this.dataService.creditorId,
        isScreenLock:false,
        module:'MyAccount'
      }
      this.dataService.postRequest('general/updatelock',lockDetails).subscribe((response) => {
        sessionStorage.clear();
      });
     }
    else if(sessionStorage.getItem('isCreditorClaimEdit') == 'true'){
      let lockDetails:any={
        lockId:this.dataService.adjudicationId,
        isScreenLock:false,
        module:'CreditorClaim'
      }
      this.dataService.postRequest('general/updatelock',lockDetails).subscribe((response) => {
        sessionStorage.clear();
      });
     }
     else if(sessionStorage.getItem('isManageUsersEdit') == 'true'){
      let lockDetails:any={
        lockId:this.dataService.creditorUserId,
        isScreenLock:false,
        module:'ManageUser'
      }
      this.dataService.postRequest('general/updatelock',lockDetails).subscribe((response) => {
        sessionStorage.clear();
      });
     }
     sessionStorage.clear();
    //Clear local storage is user signs out
    //localStorage.clear();
    if(environment.isCIAMRequired == 'true'){
      window.location.href = environment.revocationEndpoint;
    }
    else{
      this.router.navigate(['']);
    }
  }
  onClickToRedirectToHome(){
    if(this.userId && this.userId!=""){
      this.router.navigate(['creditorhome']);
    }
  }
  //A method to open claims grid by passing adjudicationid and Engagement Id
  onClickToOpenSupportingDocumentGrid(adjudicationId: any, engagementId: any){
    const dialogRef = this.dialog.open(SupportingDocumentClaimsComponent, {
      width: '1100px',
      height:'700',
      data: {
        labelCaption: this.labelCaption.Label,
         adjudicationId: adjudicationId,
         engagementId: engagementId
      },
      disableClose: true
    });
  }
  onClickToOpenSubmitOrViewMeetingGrid(adjudicationId: any, engagementId: any){
    const data ={engagementName:this.headerData.headTwo,engagementId :engagementId,creditorId:this.creditorId,podId:this.podId,engagementNameDesc:this.headerData?.headTwoDesc,creditorName:this.headerData?.creditorName};
    const url = `/adjudication-proxyform-screen?engagementName=${data.engagementName}&engagementId=${data.engagementId}&creditorId=${data.creditorId}&podId=${data.podId}&engagementNameDesc=${data.engagementNameDesc}&creditorName=${data.creditorName}&isFormBroadcast=${this.isFormHeader}`;
    window.open(url, '_blank');
  }
}
